/* eslint-disable prefer-const */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { formatDate } from '@angular/common';
import { fabric } from 'fabric';
import { MapObjectModel } from '../../models/interfaces';
import { ORIENTATION } from '../../models/enums';
import * as ShapeMaker from '../../shapes/shape.maker';
import * as ShapesLibrary from '../../shapes/shapes.library';
import { FloormapUiService } from '../../services/floormap-ui.service';
import { saveAs } from 'file-saver';
import { LocationModel } from '@kanzi-apes/kanzi-models';

const { Line, Point } = fabric;
const HORIZONTAL = 'HORIZONTAL';
const VERTICAL = 'VERTICAL';
const OFFSET = ShapeMaker.RL_ROOM_INNER_SPACING / 2;

const Left = (wall: any) => (wall.x1 < wall.x2 ? wall.x1 : wall.x2);
const Top = (wall: any) => (wall.y1 < wall.y2 ? wall.y1 : wall.y2);
const Right = (wall: any) => (wall.x1 > wall.x2 ? wall.x1 : wall.x2);
const Bottom = (wall: any) => (wall.y1 > wall.y2 ? wall.y1 : wall.y2);

@Component({
    selector: 'kanzi-floormap-content',
    templateUrl: './floormap-content.component.html',
    styleUrls: ['./floormap-content.component.scss'],
    standalone: false
})
export class FloormapContentComponent
  implements OnInit, AfterViewInit, OnChanges
{
  @Input() dataReport: {
    showRoomSelected: LocationModel;
    dataGroupFurniture: { object: any; type: string }[];
  } | null = null;
  // @Input() dataGroup: MapObjectModel[] = [];
  // @Input() floorData: {
  //   room_name: string;
  //   room_extras?: {
  //     type: string;
  //     title: string;
  //     x_position?: number;
  //     y_position?: number;
  //     width?: number;
  //     height?: number;
  //   }[];
  // } | null = null;
  @Output() clearComplete = new EventEmitter<void>();
  view!: fabric.Canvas;
  room!: fabric.Group;
  roomLayer!: fabric.Group | fabric.Rect;
  walls: fabric.Line[] = [];
  corners: any[] = [];

  CTRL_KEY_DOWN = false;
  MOVE_WALL_ID = -1;
  ROOM_SIZE = { width: 960, height: 480 };
  DEFAULT_COMPLEMENT = null;

  constructor(private floormapUIService: FloormapUiService) {}

  ngOnInit(): void {
    this.floormapUIService.performOperation.subscribe((operation) => {
      switch (operation) {
        case 'ZOOM':
          this.setZoom();
          break;
        case 'PNG':
          this.saveAsCanvas(operation);
          break;
      }
    });
  }

  ngOnChanges() {
    if (this.dataReport) {
      this.view.clear();
      const { showRoomSelected, dataGroupFurniture } = this.dataReport;
      const floorData =
        showRoomSelected && showRoomSelected.params
          ? showRoomSelected.params.data_floor
            ? showRoomSelected.params.data_floor
            : null
          : null;

      if (dataGroupFurniture && dataGroupFurniture.length) {
        dataGroupFurniture.forEach((group) => {
          this.handleObjectInsertion(group);
        });
      }

      if (floorData) {
        if (floorData.room_name) {
          const rooms = ShapesLibrary.ROOMS.filter(
            (room) => room.title === floorData?.room_name
          );
          this.handleObjectInsertion({ type: 'ROOM', object: rooms[0] });
        }
        if (floorData.room_extras) {
          floorData.room_extras.forEach((extra: any) => {
            let itemExtra: any;
            switch (extra.type) {
              case 'MISCELLANEOUS':
                itemExtra = ShapesLibrary.MISCELLANEOUS.filter(
                  (misc) => misc.title === extra.title
                )[0];
                break;
              case 'DOOR':
                itemExtra = ShapesLibrary.DOORS.filter(
                  (door) => door.title === extra.title
                )[0];
                break;

              case 'WINDOW':
                itemExtra = ShapesLibrary.WINDOWS.filter(
                  (window) => window.title === extra.title
                )[0];
                break;

              default:
                break;
            }
            if (itemExtra) {
              this.handleObjectInsertion({
                type: extra.type,
                object: {
                  ...itemExtra,
                  top: extra.y_position,
                  left: extra.x_position,
                  width: extra.width ? extra.width : itemExtra!.width,
                  height: extra.height ? extra.height : itemExtra!.height,
                  angle:extra?.angle ? extra.angle:0
                },
              });
            }
          });
        }
      }
    }

 

    // if (this.dataGroup && this.dataGroup.length) {
    //   this.dataGroup.forEach((group) => {
    //     this.handleObjectInsertion(group);
    //   });
    // } else {
    //   if (this.floorData) {
    //     if (this.floorData.room_name) {
    //       const rooms = ShapesLibrary.ROOMS.filter(
    //         (room) => room.title === this.floorData?.room_name
    //       );
    //       this.handleObjectInsertion({ type: 'ROOM', object: rooms[0] });
    //     }
    //     if (this.floorData.room_extras) {
    //       this.floorData.room_extras.forEach((extra) => {
    //         let itemExtra: any;
    //         switch (extra.type) {
    //           case 'MISCELLANEOUS':
    //             itemExtra = ShapesLibrary.MISCELLANEOUS.filter(
    //               (misc) => misc.title === extra.title
    //             )[0];
    //             break;
    //           case 'DOOR':
    //             itemExtra = ShapesLibrary.DOORS.filter(
    //               (door) => door.title === extra.title
    //             )[0];
    //             break;

    //           case 'WINDOW':
    //             itemExtra = ShapesLibrary.WINDOWS.filter(
    //               (window) => window.title === extra.title
    //             )[0];
    //             break;

    //           default:
    //             break;
    //         }
    //         if (itemExtra) {
    //           this.handleObjectInsertion({
    //             type: extra.type,
    //             object: {
    //               ...itemExtra,
    //               top: extra.y_position,
    //               left: extra.x_position,
    //               width: extra.width ? extra.width : itemExtra!.width,
    //               height: extra.height ? extra.height : itemExtra!.height,
    //             },
    //           });
    //         }
    //       });
    //     }
    //   }
    // }
  }

  clearLayout(){
    console.log("🚀 ~ file: floormap-content.component.ts:205 ~ clearLayout ~ this.view:", this.view)
    this.view.clear();
  }

  ngAfterViewInit() {
    this.setCanvasView();
  }

  /**
   * Init The Canvas View & Bind Events
   */
  setCanvasView() {
    const canvas = new fabric.Canvas('floor-main', {
      preserveObjectStacking: true,
    });
    canvas.setWidth(ShapeMaker.RL_VIEW_WIDTH * ShapeMaker.RL_FOOT);
    canvas.setHeight(ShapeMaker.RL_VIEW_HEIGHT * ShapeMaker.RL_FOOT);
    canvas.setZoom(1);
    this.view = canvas;

    this.view.on('selection:created', (e: fabric.IEvent) => {
      this.onSelected();
    });

    this.view.on('selection:updated', (e: fabric.IEvent) => {
      this.onSelected();
    });

    this.view.on('selection:cleared', (e: fabric.IEvent) => {
      this.floormapUIService.selections = [];
      this.floormapUIService.ungroupable = false;
    });
  }

  onSelected() {
    const active = this.view.getActiveObject();
    (active!.lockScalingX = true), (active!.lockScalingY = true);
    if (!active!.name) {
      active!.name = 'GROUP';
    }
  }

  /**
   *
   * @param type {string}
   * @param object {any}
   */
  handleObjectInsertion({ type, object }: any) {
    if (type === 'ROOM') {
      this.setRoom(object);
      return;
    }
    const group = ShapeMaker.createFurniture(type, object);

    if (type === 'DOOR' || type === 'WINDOW') {
      group.originX = 'center';
      group.originY = 'top';
      group.hasControls = false;
      group.hasBorders = false;
      this.view.add(group);

      return;
    }
    console.log(group);
    this.view.add(group);
  }

  /**
   * Draw Room defined in a Model
   * @param dimensions {width:number, height: number}
   */
  setRoom({ width, height }: any) {
    if (this.walls.length) {
      this.view.remove(...this.walls);
      this.view.renderAll();
    }

    const LT = new Point(
      ShapeMaker.RL_ROOM_OUTER_SPACING,
      ShapeMaker.RL_ROOM_OUTER_SPACING
    );
    const RT = new Point(LT.x + width, LT.y);
    const LB = new Point(LT.x, LT.y + height);
    const RB = new Point(RT.x, LB.y);

    this.corners = [LT, RT, RB, LB].map((p) => this.drawCorner(p));
    this.drawRoom();
  }

  /**
   * Draw the Room
   */
  drawRoom() {
    const exists = this.view
      .getObjects()
      .filter((obj) => obj.name!.indexOf('WALL') > -1 || obj.name === 'CORNER');
    this.view.remove(...exists);
    this.view.add(...this.corners);

    const wall = (coords: number[], index: number) =>
      new Line(coords, {
        stroke: ShapeMaker.RL_ROOM_STROKE,
        strokeWidth: ShapeMaker.RL_ROOM_INNER_SPACING,
        name: `WALL:${index}`,
        originX: 'center',
        originY: 'center',
        hoverCursor: this.floormapUIService.roomEdit
          ? this.view.moveCursor
          : this.view.defaultCursor,
        hasControls: false,
        hasBorders: false,
        selectable: this.floormapUIService.roomEdit,
        evented: this.floormapUIService.roomEdit,
        cornerStyle: 'rect',
      });
    let LT = new Point(9999, 9999),
      RB = new Point(0, 0);

    this.walls = this.corners.map((corner, i) => {
      const start = corner;
      const end =
        i === this.corners.length - 1 ? this.corners[0] : this.corners[i + 1];

      if (corner.top < LT.x && corner.left < LT.y) {
        LT = new Point(corner.left, corner.top);
      }
      if (corner.top > RB.y && corner.left > RB.y) {
        RB = new Point(corner.left, corner.top);
      }

      const w = wall([start.left, start.top, end.left, end.top], i);
      return w;
    });

    this.view.add(...this.walls);
    this.walls.forEach((w) => w.sendToBack());
    this.ROOM_SIZE = { width: RB.x - LT.x, height: RB.y - LT.y };
  }

  /**
   * @name filterObjects
   * @param names {string[]}
   * @description Filter Map Elements by Name
   */
  filterObjects(names: string[]) {
    return this.view
      .getObjects()
      .filter((obj: any) => names.some((n) => obj.name!.indexOf(n) > -1));
  }

  wallOfDW(dw: fabric.Group | fabric.Object) {
    const d = dw.angle! % 180 === 0 ? HORIZONTAL : VERTICAL;
    return this.walls.find(
      (w) =>
        Math.abs(d === HORIZONTAL ? w.top! - dw.top! : w.left! - dw.left!) ===
        OFFSET
    );
  }

  directionOfWall(wall: fabric.Line) {
    if (wall.x1 === wall.x2) {
      return VERTICAL;
    } else {
      return HORIZONTAL;
    }
  }

  /**
   *@name locateDW
   * @param dw {Group}
   * @param wall {Line}
   * @param x {number}
   * @param y {number}
   *
   * @description Locate the Door or Window inside the Room
   */
  locateDW(dw: fabric.Group, wall: fabric.Line, x: number, y: number) {
    const dWall = this.directionOfWall(wall);
    const dDW = dw.angle! % 180 === 0 ? HORIZONTAL : VERTICAL;
    if (dWall !== dDW) {
      dw.angle = (dw.angle! + 90) % 360;
    }
    (dw.top = y), (dw.left = x);
    const center = dw.getCenterPoint();
    if (dWall === HORIZONTAL) {
      center.y < dw.top ? (dw.top += OFFSET) : (dw.top -= OFFSET);
    } else {
      center.x < dw.left ? (dw.left += OFFSET) : (dw.left -= OFFSET);
    }
    return dw;
  }

  /**
   * @name drawCorner
   * @param p {Point}
   *
   * @returns {Rect}
   */
  drawCorner(p: fabric.Point): fabric.Rect {
    const c = new fabric.Rect({
      left: p.x,
      top: p.y,
      strokeWidth: 0,
      hasControls: false,
      originX: 'center',
      originY: 'center',
      name: 'CORNER',
    });
    this.setCornerStyle(c);
    return c;
  }

  /**
   * @name setCornerStyle
   * @param c {Rect}
   */
  setCornerStyle(c: fabric.Rect) {
    c.moveCursor = this.view.freeDrawingCursor;
    c.hoverCursor = this.view.freeDrawingCursor;
    c.selectable = false;
    c.evented = false;
    c.width = c.height = (ShapeMaker.RL_ROOM_INNER_SPACING / 2) * 2;
    c.set('fill', ShapeMaker.RL_ROOM_STROKE);
  }

  addElementToRoom(elemObj: MapObjectModel) {
    let group = ShapeMaker.createFurniture(
      elemObj.type,
      elemObj.object,
      this.DEFAULT_COMPLEMENT
    );

    if (elemObj.type === 'DOOR' || elemObj.type === 'WINDOW') {
      group = { ...group, originX: 'center', originY: 'top' };
      const dw = elemObj.object;

      let wall, x, y;
      x = elemObj.object.left;
      y = elemObj.object.top;
      const od =
        elemObj.object.angle % 180 === 0
          ? ORIENTATION.HORIZONTAL
          : ORIENTATION.VERTICAL;
      wall = this.wallOfDW(group);
      this.locateDW(group, wall!, x, y);
      group.hasBorders = false;
      this.view.add(group);
      return;
    }
  }

  isDW(object: any) {
    return (
      object.name.indexOf('DOOR') > -1 || object.name.indexOf('WINDOW') > -1
    );
  }

  getBoundingRect(objects: any[]) {
    let top = 9999,
      left = 9999,
      right = 0,
      bottom = 0;
    objects.forEach((obj) => {
      if (obj.left < top) {
        top = obj.top;
      }
      if (obj.left < left) {
        left = obj.left;
      }
      if (obj.top > bottom) {
        bottom = obj.top;
      }
      if (obj.left > right) {
        right = obj.left;
      }
    });

    const center = (left + right) / 2;
    const middle = (top + bottom) / 2;

    return { left, top, right, bottom, center, middle };
  }

  saveAsCanvas(format: string) {
    const width = this.view.getWidth();
    const height = this.view.getHeight();
    this.view.setBackgroundColor('white', () => {console.log('white')});

    const credit = new fabric.Text(ShapeMaker.RL_CREDIT_TEXT, {
      ...ShapeMaker.RL_CREDIT_TEXT_PARAMS,
      left: ShapeMaker.RL_ROOM_OUTER_SPACING,
      top: height - (ShapeMaker.RL_CREDIT_TEXT_PARAMS.fontSize + 10),
    });

    this.view.add(credit);
    this.view.discardActiveObject();
    this.view.renderAll();

    const restore = () => {
      this.view.remove(credit);
      this.view.setBackgroundColor('transparent', () => {console.log('transparent')});
      this.view.setWidth(width);
      this.view.setHeight(height);
      this.view.renderAll();
    };

    if (format === 'PNG') {
      const canvas: any = document.getElementById('floor-main');
      canvas.toBlob((blob: Blob) => {
        saveAs(
          blob,
          `location_layout_${formatDate(
            new Date(),
            'yyyy-MM-dd-hh-mm-ss',
            'en'
          )}.png`
        );
        restore();
      });
    }
  }

  setZoom() {
    const actualZoom = this.view.getZoom();
    const newZoom = this.floormapUIService.zoom / 100;
    const actualHeight = this.view.getHeight();
    const actualWidth = this.view.getWidth();
    if (actualZoom < newZoom) {
      this.view.setZoom(newZoom);
      if (actualZoom >= 1) {
        this.view.setHeight(actualHeight * newZoom);
        this.view.setWidth(actualWidth * newZoom);
      } else {
        this.view.setWidth(ShapeMaker.RL_VIEW_WIDTH * ShapeMaker.RL_FOOT);
        this.view.setHeight(ShapeMaker.RL_VIEW_HEIGHT * ShapeMaker.RL_FOOT);
      }
    } else if (actualZoom > newZoom) {
      this.view.setZoom(newZoom);
      if (actualZoom >= 1) {
        this.view.setHeight(actualHeight / actualZoom);
        this.view.setWidth(actualWidth / actualZoom);
      } else {
        this.view.setWidth(ShapeMaker.RL_VIEW_WIDTH * ShapeMaker.RL_FOOT);
        this.view.setHeight(ShapeMaker.RL_VIEW_HEIGHT * ShapeMaker.RL_FOOT);
      }
    }
    this.view.renderAll();
  }
}
